/**
 * @generated SignedSource<<71a7540ec9f95d4919ae67d20a96933a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppLeftSidebarProductsWarningFragment$data = {
  readonly treeMenuReferringInfo: {
    readonly firstNotPublishedProductID: number | null;
    readonly hasFirstCustomizableProduct: boolean;
    readonly hasPublishedProduct: boolean;
  };
  readonly " $fragmentType": "AppLeftSidebarProductsWarningFragment";
};
export type AppLeftSidebarProductsWarningFragment$key = {
  readonly " $data"?: AppLeftSidebarProductsWarningFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppLeftSidebarProductsWarningFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppLeftSidebarProductsWarningFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TreeMenuReferringInfo",
      "kind": "LinkedField",
      "name": "treeMenuReferringInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstNotPublishedProductID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasFirstCustomizableProduct",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPublishedProduct",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "f547d7fbf7c1beb1fc799f27c88bb446";

export default node;
